import { render, staticRenderFns } from "./RegisterSectionDlg.vue?vue&type=template&id=50c634e6"
import script from "./RegisterSectionDlg.vue?vue&type=script&lang=js"
export * from "./RegisterSectionDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports